import { Flex, Text, useThemeValue } from "@gravity-ui/uikit";
import React from "react";
import { useGravityDevice } from "src/hooks/useGravityDevice";

import { InSalesLogo, WooCommerceLogo } from "../Icons";
import { TextSection } from "../TextSection";
import { usePlatformComprasionBlockTranslate } from "./hooks/usePlatformComprasionBlockTranslate";

export const PlatformComparisonBlock = () => {
  const { isMobile } = useGravityDevice();
  const themeValue = useThemeValue();

  const { title, description, comparisonData } =
    usePlatformComprasionBlockTranslate();

  return (
    <Flex
      id="platform-comparison"
      direction={"column"}
      width={"100%"}
      maxWidth={"1440px"}
      style={{
        paddingLeft: isMobile ? 30 : 50,
        paddingRight: isMobile ? 30 : 50,
        gap: 60,
      }}
    >
      <TextSection title={title} description={description} />

      <Flex direction={"column"} gap={4}>
        <Flex
          alignItems={"center"}
          justifyContent={"end"}
          gap={4}
          direction={isMobile ? "column" : "row"}
        >
          <Flex
            gap={6}
            width={isMobile ? "100%" : "50%"}
            alignItems={"center"}
            justifyContent={"space-around"}
          >
            <WooCommerceLogo />
            <InSalesLogo color={themeValue === "dark" ? "white" : undefined} />
          </Flex>
        </Flex>
        {comparisonData.map((item, index, array) => {
          return (
            <React.Fragment key={`comparison.${index}`}>
              <Flex
                alignItems={"center"}
                justifyContent={"space-between"}
                gap={4}
                direction={isMobile ? "column" : "row"}
              >
                <Text variant="subheader-2" color="info">
                  {item.title}
                </Text>
                <Flex gap={6} width={isMobile ? "100%" : "50%"}>
                  <Text
                    style={{
                      maxWidth: 300,
                      width: "100%",
                      textAlign: isMobile ? "center" : "start",
                    }}
                  >
                    {item.woocommerce.title}
                  </Text>
                  <Text
                    style={{
                      maxWidth: 300,
                      width: "100%",
                      textAlign: isMobile ? "center" : "start",
                    }}
                  >
                    {item.insales.title}
                  </Text>
                </Flex>
              </Flex>

              {array.length !== index + 1 && (
                <div
                  style={{
                    height: 1,
                    background: "var(--g-color-base-generic)",
                  }}
                />
              )}
            </React.Fragment>
          );
        })}
      </Flex>
    </Flex>
  );
};
